import type { ReactNode } from "react";

interface DetailItemProps {
  label: string;
  value?: ReactNode;
}

export const DetailItem = ({ label, value }: DetailItemProps) => (
  <div>
    <h5 className="form-label">{label}</h5>
    <div className="form-control--value">{value || "-"}</div>
  </div>
);
